import { TranslationInfo } from "@shared/types/translation-info";
import { TableFilterGroup } from "./table-filter-group.type";

// eslint-disable-next-line @tseslint/typedef
export const TABLE_FILTER_TYPES = {
  SELECT: "select",
  START_DATE: "start-date",
  END_DATE: "end-date"
} as const;
export type TableFilterType = typeof TABLE_FILTER_TYPES[keyof typeof TABLE_FILTER_TYPES];
export function findFilterByType (group: TableFilterGroup, filterType: TableFilterType): TableFilter | undefined {
  return group.children.find((filter: TableFilter): boolean => filter.filterValue.filterType === filterType);
}
// Todo clean up --> split into smaller files
export interface DateFilter {
  filterType: typeof TABLE_FILTER_TYPES.START_DATE | typeof TABLE_FILTER_TYPES.END_DATE;
  date?: Date | undefined;
}
export interface SelectFilter {
  filterType: typeof TABLE_FILTER_TYPES.SELECT;
  isSelected: boolean;
  /** The value that the paramName should have. */
  value?: string;
}
export interface BaseTableFilter {
  /** The name of Filter (must be unique within the group) */
  readonly selector: string;
  filterValue: DateFilter | SelectFilter;
}
export interface TableFilter extends BaseTableFilter {
  filterNameTranslationInfo?: TranslationInfo | undefined;
  filterName?: string | undefined;
  paramName: string;
}
export function parseToBaseTableFilter (tableFilter: TableFilter): BaseTableFilter {
  return { selector: tableFilter.selector, filterValue: tableFilter.filterValue };
}
